import styled from "@emotion/styled";
import Image from "next/image";
import { Container, Desktop, useIsLargeDesktop } from "ui";
import { getNonUmbracoURL } from "utils/utils";
import ChargeForm from "./ChargeForm";

const StyledWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding-top: 50px;
padding-bottom: 50px;
background: rgba(21, 62, 105, 0.1);
`
const StyledLayout = styled.div`
display: flex;
justify-content: center;
align-items: center
`
type Props = {
    data: any
}
function ContactUsCharge({ data }: Props) {
    const isLargeDesktop = useIsLargeDesktop()
    return (
        <StyledWrapper>
            <Container>
                <StyledLayout>
                    <Desktop>
                        <Image
                            src={getNonUmbracoURL("https://corporatecmsqa.paz.co.il/media/l2aazh3s/1-61-44_tmunot_campaigns_960x920.png")}
                            alt="contact us image"
                            width={isLargeDesktop ? 588 : 457}
                            height={600}
                            style={{ objectFit: "contain" }}
                        />
                    </Desktop>
                    <ChargeForm data={data}></ChargeForm>
                </StyledLayout>
            </Container>
        </StyledWrapper>
    );
}

export default ContactUsCharge;
